import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ceo',
  templateUrl: './ceo.component.html',
  styleUrls: ['./ceo.component.scss']
})
export class CeoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
